module.exports = __webpack_public_path__ + "static/img/folkSong_share.ba8f8ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/folkSong_share.jpg
// module id = mEWe
// module chunks = 26